import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { colors } from "UI/colors";

export default function Untouched() {
  return (
    <Wrapper exit={{ opacity: 0, height: 0 }}>
      <Inside exit={{ y: "-100%" }}>
        <Placeholder data-cy="paymentsPageNoUserLoggedIn">
          Contact Info
        </Placeholder>
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  height: auto;
`;

const Inside = styled(motion.div)`
  padding: 0 14px;
`;

const Placeholder = styled.div`
  color: #828c8d;
  font-size: 20px;
  font-weight: 400;
`;
